import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SortDir,
  SchemaFilterType,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: 'Transaction identifier',
    hidden: true,
  },
  {
    name: 'deletedAt',
    label: 'Deleted At',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: true,
  },
  {
    name: 'sum',
    label: 'Amount',
    sortable: true,
  },
  {
    name: 'recipientAccountNumber',
    label: 'Beneficiary account',
    sortable: true,
  },
  {
    name: 'paymentType',
    label: 'Payment type',
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'senderAccountNumber',
    label: 'Account',
    filterModalPlacement: 'right',
    sortable: true,
  },
];

export const columnsLabels = {
  currencyId: 'Currency',
  recipientAccountNumber: 'Beneficiary account',
  senderAccountNumber: 'Account',
};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recipientAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  baseellaStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'recipientAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'senderAccountNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter Account/IBAN...',
  },
];
